module.exports = "/dashboard/_next/static/images/banner-mfa-e18962a5d77c64ac6ea1b71ee6c7bb8b.png";